import React, { useEffect, createElement } from 'react';
import Home from './pages/Home';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    const preloadHero = document.createElement('link');
    preloadHero.rel = 'preload';
    preloadHero.as = 'image';
    preloadHero.href = 'https://cdn.magicpatterns.com/uploads/bAgN1RC2bw7eCB167SshQW/17f95cff-c426-4d98-84ce-1917901eb530_(1).png';
    (preloadHero as any).fetchPriority = 'high';
    document.head.appendChild(preconnect1);
    document.head.appendChild(preconnect2);
    document.head.appendChild(preloadHero);
  }, []);
  return <>
      <MetaPixel data-id="element-0" />
      <Home data-id="element-1" />
    </>;
}